import { AuthorizationProvider } from "./AuthorizationProvider";
import { IdentityProvider } from "./IdentityProvider";

export { IdentityProvider } from "./IdentityProvider";
export { AuthorizationProvider } from "./AuthorizationProvider";

export { RouteSecurity, checkAccess } from "./RouteSecurity";

export type SecurityProvider = IdentityProvider & AuthorizationProvider;
